var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewInQbDisabledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10H10V7H9V9H1V1H3V0H0V10Z",
    fill: "#a19f9d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 0H10V5L8.20625 3.20625L4.41563 7L3 5.58437L6.79375 1.79062L5 0Z",
    fill: "#a19f9d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewInQbDisabledIcon);
export default __webpack_public_path__ + "static/media/ViewInQBDisabledIcon.e141646ec9747d52443c08f23aff1e18.svg";
export { ForwardRef as ReactComponent };